import { render, staticRenderFns } from "./AsiaPolicyDetail.vue?vue&type=template&id=74d9b65f"
import script from "./AsiaPolicyDetail.vue?vue&type=script&lang=js"
export * from "./AsiaPolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports